module.exports = __webpack_public_path__ + "static/img/top_pic1.73ed622.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top_pic1.jpg
// module id = r7mm
// module chunks = 1